import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { createFaqs, deleteFaq, GetFaqs, GetInstructionVedio, updateAdminFaq, uploadFile, uploadSingleDocument, uploadVideo } from "../../apis";


function Faq() {
  const [faqs, setFaqs] = useState([]);
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [editingId, setEditingId] = useState(null);

  const [selectedFile, setSelectedFile] = useState(null);
  const [fileUrl, setFileUrl] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchFaqs();
    FetchGetInstructionVedio()
  }, []);

  const fetchFaqs = async () => {
    try {
      const response = await GetFaqs();
      setFaqs(response.data.data);
    } catch (error) {
      console.error("Error fetching FAQs:", error);
    }
  };

  const FetchGetInstructionVedio = async () => {
    try {
      const response = await GetInstructionVedio();
      console.log("response",response.data.data.videoUrl)
      setFileUrl(response.data.data.videoUrl)
    } catch (error) {
    
    }
  };

  

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingId) {
        // Update FAQ
        await updateAdminFaq(editingId, { question, answer });
      } else {
        // Create new FAQ
        await createFaqs({
          question,
          answer,
        });
      }
      setQuestion("");
      setAnswer("");
      setEditingId(null);
      fetchFaqs();
    } catch (error) {
      console.error("Error saving FAQ:", error);
    }
  };

  const handleEdit = (faq) => {
    setQuestion(faq.question);
    setAnswer(faq.answer);
    setEditingId(faq._id);
  };

  const handleDelete = async (id) => {
    try {
      await deleteFaq(id);
      fetchFaqs();
    } catch (error) {
      console.error("Error deleting FAQ:", error);
    }
  };


  // instructuin vedio

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleUpload = async () => {
    setLoading(true);
    try {
      if (selectedFile) {
        await fileUploadHandler(selectedFile);
        toast.success("Video uploaded successfully");
      }
    } catch (error) {
      // Optionally handle error here
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const fileUploadHandler = useCallback(
    async (file) => {
      if (!file) return;

      try {
        const form = new FormData();
        form.append("file", file);
        console.log("file", file)
        const apiResponse = await uploadVideo(form);
        console.log("apiResponse", apiResponse)
        setFileUrl(apiResponse?.data?.url)


      } catch (error) {

        if (error?.response?.status === 401);
      }
    },
    []
  );


  return (
    <div className="category-subcategory-container" style={{ display: "flex", gap: "20px" }}>
      {/* Left side - Form */}
      <div className="faq-form" style={{ width: "40%", padding: "20px", border: "1px solid #ccc" }}>
        <h2 className="heading">{editingId ? "Edit FAQ" : "Add FAQ"}</h2>
        <form onSubmit={handleSubmit} style={{ marginTop: '20px' }}>
          <div>
            <label>Question:</label>
            <br />
            <input
              type="text"
              value={question}
              onChange={(e) => setQuestion(e.target.value)}
              required
              style={{ width: "100%", padding: "8px", marginBottom: "10px" }}
            />
          </div>
          <br />
          <div>
            <label>Answer:</label>
            <br />
            <textarea
              value={answer}
              onChange={(e) => setAnswer(e.target.value)}
              required
              style={{ width: "100%", padding: "8px", marginBottom: "10px" }}
            ></textarea>
          </div>
          <button type="submit" className="addRfq_btn" style={{ padding: "10px 15px", color: "white", border: "none" }}>
            {editingId ? "Update FAQ" : "Add FAQ"}
          </button>
        </form>

        
        <div>
          <h2 className="heading mt-10">Instruction Video</h2>
          <div className="df">
            <input type="file" onChange={handleFileChange} />
            <button
              onClick={handleUpload}
              disabled={!selectedFile}
              style={{
                color: "#111",
                margin: "12px",
                border: "1px solid black",
                borderRadius: "4px",
              }}
            >
              {loading ? "Uploading..." : "Upload"}
            </button>
          </div>

          {fileUrl && (
            <div>
          
              <video width="400" controls>
                <source src={fileUrl} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          )}

        </div>




      </div>

      {/* Right side - FAQ List */}
      <div className="faq-list" style={{ width: "60%", padding: "20px", border: "1px solid #ccc" }}>

        {faqs.length > 0 ? (
          <ul style={{ listStyle: "none", padding: 0 }}>
            {faqs.map((faq) => (
              <li key={faq._id} className="df jsb" style={{ marginBottom: "15px", padding: "10px", borderBottom: "1px solid #ddd" }}>
                <div>
                  <b className="que">Question : </b><strong>{faq.question}</strong><br /><br />
                  <b className="ans">Answer : </b><strong>{faq.answer}</strong>
                </div>
                <div className="df ">
                  <button
                    onClick={() => handleEdit(faq)}
                    style={{
                      marginRight: "10px",
                      border: "1px solid black",
                      borderRadius: "4px",
                      color: "black",
                      cursor: "pointer",
                    }}
                  >
                    Edit
                  </button>
                  <button onClick={() => handleDelete(faq._id)} style={{ color: "red", cursor: "pointer" }}>
                    Delete
                  </button>
                </div>
              </li>
            ))}
          </ul>
        ) : (
          <p>No FAQs available.</p>
        )}
      </div>
    </div>
  );
}

export default Faq;
